"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var microsoftTeams = require("@microsoft/teams-js");
var Icons_1 = require("office-ui-fabric-react/lib/Icons");
var serventias_api_1 = require("../../api/serventias-api");
var user_api_1 = require("../../api/user-api");
var react_northstar_1 = require("@fluentui/react-northstar");
var react_icons_northstar_1 = require("@fluentui/react-icons-northstar");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var visao_geral_atendimentos_status_1 = require("./visao-geral-atendimentos-status/visao-geral-atendimentos-status");
var visao_geral_atendimentos_1 = require("../home/visao-geral-atendimentos/visao-geral-atendimentos");
var relatorio_atendimentos_1 = require("../home/relatorio-atendimentos/relatorio-atendimentos");
var loaderList_1 = require("../loaders/loaderList");
var loaderPainel_1 = require("../loaders/loaderPainel");
var status_queue_1 = require("../../constants/status-queue");
var errors_1 = require("../../constants/errors");
var listagem_fila_1 = require("./listagem-atendimentos/listagem-fila");
var listagem_iniciado_1 = require("./listagem-atendimentos/listagem-iniciado");
var listagem_encerrado_1 = require("./listagem-atendimentos/listagem-encerrado");
var listagem_expirado_1 = require("./listagem-atendimentos/listagem-expirado");
var toolbar_1 = require("./toolbar/toolbar");
var react_i18next_1 = require("react-i18next");
require("./painel-atendimento.scss");
var moment = require('moment');
var PainelAtendimento = /** @class */ (function (_super) {
    __extends(PainelAtendimento, _super);
    function PainelAtendimento(props) {
        var _this = _super.call(this, props) || this;
        _this.defaultPageSize = 50;
        _this.ancora = null;
        _this.serventiaTitle = null;
        _this.serventiaMeetingUrl = null;
        _this.theme = null;
        _this.upn = null;
        _this.aadId = null;
        _this.user = null;
        _this.tid = null;
        _this.appId = null;
        _this.searchParam = null;
        _this.init = function () { return __awaiter(_this, void 0, void 0, function () {
            var keepAlive;
            var _this = this;
            return __generator(this, function (_a) {
                if (this.ancora) {
                    this.getMeeting();
                    this.addLastViewUnidade();
                }
                else {
                    this.ancora = this.state.userSettings.lastViewUnidadeAncora;
                    this.serventiaTitle = this.state.userSettings.lastViewUnidadeTitle;
                    if (this.ancora) {
                        this.getMeeting();
                    }
                }
                this.getAllMeetingData(this.state.statusQueue, this.state.selectedDateFilter);
                clearInterval(this.state.interval);
                keepAlive = setInterval(function () { return _this.getAllMeetingData(_this.state.statusQueue, _this.state.selectedDateFilter, _this.state.selectedAtendenteFilter, _this.state.selectedFilter); }, 20000);
                this.setState({ interval: keepAlive });
                this.getFilteredMetrics(1); // Atendimentos no dia.
                this.getFilteredAllMetrics(7, 0); // 7 dias no primeiro carregamento / 0 tabIndex.
                this.getAtendimentosPorStatusFilteredMetrics(0); // Visão geral de atendimentos por status.
                this.getAtendimentosFilteredMetrics(0); // Visão geral de atendimentos por unidade.
                this.getAtendimentosTotalMetrics(); // Visão geral de atendimentos (totais)
                this.getRelatorioAtendimentosFilteredMetrics(7);
                this.getAtendentes(this.state.selectedDateFilter);
                return [2 /*return*/];
            });
        }); };
        //Get serventia by id
        _this.getMeeting = function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, serventias_api_1.getMeetingData(this.ancora)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                serventia: response.data,
                                isDeleted: response.data.deleted,
                                isScheduledQueue: response.data.scheduledQueue,
                                authEnabled: response.data.authEnabled,
                                govBrEnabled: response.data.govBrEnabled,
                                internalAccessEnabled: response.data.internalAccessEnabled,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        //Insert the last view Serventia
        _this.addLastViewUnidade = function () { return __awaiter(_this, void 0, void 0, function () {
            var responseUpdate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.state.userSettings.lastViewUnidadeAncora = this.ancora;
                        this.state.userSettings.lastViewUnidadeTitle = this.serventiaTitle;
                        return [4 /*yield*/, user_api_1.updateUserSettings(this.state.userSettings)];
                    case 1:
                        responseUpdate = _a.sent();
                        if (responseUpdate.status === 200 && responseUpdate.data) {
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        //Get user settings.
        _this.getUserSettings = function () { return __awaiter(_this, void 0, void 0, function () {
            var responseGet;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, user_api_1.getUserSettings()];
                    case 1:
                        responseGet = _a.sent();
                        if (responseGet.data) {
                            this.setState({
                                userSettings: responseGet.data
                            });
                            this.init();
                        }
                        else {
                            window.location.href = "/errorpage/" + errors_1.default.invalidUserData;
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Get Filtered Metrics Data
         * */
        _this.getFilteredMetrics = function (filter) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, serventias_api_1.getFilteredMetricsItemData(this.ancora, filter)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                metricsFiltered: response.data
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.getFilteredAllMetrics = function (filter, index) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({
                            loadingTotalMetricsFiltered: true,
                        });
                        return [4 /*yield*/, serventias_api_1.getFilteredMetricsItemData(this.ancora, filter)];
                    case 1: return [4 /*yield*/, _a.sent()];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                totalMetricsFiltered: response.data,
                                loadingTotalMetricsFiltered: false,
                                totalIndex: index,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Get visão geral atendimentos filter metrics
         * */
        _this.getAtendimentosPorStatusFilteredMetrics = function (daysCount, index) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (index == null) {
                            this.setState({
                                loadingAtendimentosPorStatusMetricsFiltered: true,
                            });
                        }
                        return [4 /*yield*/, serventias_api_1.getGeneralViewUnidadeData(this.ancora, daysCount)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                atendimentosPorStatusMetricsFiltered: response.data,
                                loadingAtendimentosPorStatusMetricsFiltered: false,
                                atendimentosPorStatusIndex: index == null ? 0 : index,
                            });
                        }
                        else {
                            this.setState({
                                atendimentosPorStatusMetricsFiltered: null,
                                loadingAtendimentosPorStatusMetricsFiltered: false,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Get visão geral filter metrics by ancora
         * */
        _this.getAtendimentosFilteredMetrics = function (daysCount, index) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (index == null) {
                            this.setState({
                                loadingAtendimentosMetricsFiltered: true,
                            });
                        }
                        return [4 /*yield*/, serventias_api_1.getGeneralViewData(daysCount, this.ancora)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                atendimentosMetricsFiltered: response.data,
                                loadingAtendimentosMetricsFiltered: false,
                                atendimentosIndex: index == null ? 0 : index,
                            });
                        }
                        else {
                            this.setState({
                                atendimentosMetricsFiltered: null,
                                loadingAtendimentosMetricsFiltered: false,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Get visão geral total metrics by ancora
         * */
        _this.getAtendimentosTotalMetrics = function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({
                            loadingAtendimentosTotalMetrics: true,
                        });
                        return [4 /*yield*/, serventias_api_1.getMetricsData(this.ancora)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                atendimentosTotalMetrics: response.data,
                                loadingAtendimentosTotalMetrics: false,
                            });
                        }
                        else {
                            this.setState({
                                atendimentosTotalMetrics: null,
                                loadingAtendimentosTotalMetrics: false,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Get relatório de atendimentos.
         * */
        _this.getRelatorioAtendimentosFilteredMetrics = function (daysCount, index) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (index == null) {
                            this.setState({
                                loadingMetricsFiltered: true,
                            });
                        }
                        return [4 /*yield*/, serventias_api_1.getAttendancesReportData(daysCount, this.ancora)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                relatorioAtendimentosFilteredMetrics: response.data,
                                loadingMetricsFiltered: false,
                                relatorioAtendimentosIndex: index == null ? 0 : index,
                            });
                        }
                        else {
                            this.setState({
                                relatorioAtendimentosFilteredMetrics: null,
                                loadingMetricsFiltered: false,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Filter Assunto or Protocol.
         * */
        _this.filterAssuntoOrProtocol = function (filter) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.setState({
                    selectedFilter: filter,
                    status: 1,
                }, function () {
                    _this.setActiveTabId(1, "'" + status_queue_1.default.naFila + "', '" + status_queue_1.default.atendimentoAgendado + "'");
                    clearInterval(_this.state.interval);
                });
                return [2 /*return*/];
            });
        }); };
        _this.getAtendentes = function (date) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, serventias_api_1.getAtendentesFilter(this.ancora, date)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                atendentes: response.data,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.searchFilters = function (e) {
            var searchQuery = e.target.value;
            _this.setState({
                selectedFilter: searchQuery,
            });
        };
        _this.applyFilters = function (dateFilter, atendenteFilter) {
            clearInterval(_this.state.interval);
            if (atendenteFilter) {
                _this.setState({
                    selectedDateFilter: dateFilter,
                    selectedAtendenteFilter: atendenteFilter,
                    selectedFilter: "",
                }, function () {
                    if (moment(dateFilter).isSame(moment(), "day")) {
                        _this.setActiveTabId(2, "'" + status_queue_1.default.atendimentoIniciado + "', '" + status_queue_1.default.emAtendimento + "'");
                    }
                    else {
                        if (moment(dateFilter).isBefore(moment(), "day"))
                            _this.setActiveTabId(3, "'" + status_queue_1.default.atendimentoEncerrado + "',  '" + status_queue_1.default.atendimentoInativo + "', '" + status_queue_1.default.atendimentoCancelado + "'");
                        if (moment(dateFilter).isAfter(moment(), "day"))
                            _this.setActiveTabId(1, "'" + status_queue_1.default.naFila + "', '" + status_queue_1.default.atendimentoAgendado + "'");
                    }
                });
            }
            else {
                _this.dateChange(dateFilter);
            }
        };
        _this.applyProtocolFilter = function () {
            _this.setState({
                status: 0,
                loadingRows: true,
                selectedAtendenteFilter: "",
            }, function () {
                clearInterval(_this.state.interval);
                _this.filterAssuntoOrProtocol(_this.state.selectedFilter.replace(/#/g, ""));
            });
        };
        _this.clearFilters = function () {
            _this.setState({
                selectedFilter: "",
                loadingRows: true,
                status: 1,
                statusQueue: "'" + status_queue_1.default.naFila + "', '" + status_queue_1.default.atendimentoAgendado + "'",
                statusLabel: _this.localize("SolicitacoesAguardandoAtendimento"),
                selectedAtendenteFilter: "",
                selectedDateFilter: new Date(),
            }, function () {
                clearInterval(_this.state.interval);
                _this.getAllMeetingData(_this.state.statusQueue, new Date());
                var keepAlive = setInterval(function () { return _this.getAllMeetingData(_this.state.statusQueue, new Date()); }, 20000);
                _this.setState({ interval: keepAlive });
            });
        };
        _this.dateChange = function (date) {
            _this.setState({
                status: 0,
                selectedDateFilter: date,
                loadingRows: true,
            });
            if (moment(date).isSame(moment(), "day")) {
                _this.setState({
                    status: 1,
                    statusQueue: "'" + status_queue_1.default.naFila + "', '" + status_queue_1.default.atendimentoAgendado + "'",
                });
                _this.getAllMeetingData(null, date);
            }
            else {
                if (moment(date).isBefore(moment(), "day")) {
                    _this.setState({
                        status: 3,
                        statusQueue: 3,
                    });
                    _this.getAllMeetingData(3, date);
                }
                if (moment(date).isAfter(moment(), "day")) {
                    _this.setState({
                        status: 1,
                        statusQueue: "'" + status_queue_1.default.naFila + "', '" + status_queue_1.default.atendimentoAgendado + "'",
                    });
                    _this.getAllMeetingData(null, date);
                }
            }
        };
        _this.getLabelStatusLocale = function (status) {
            if (status) {
                if (status == status_queue_1.default.naFila)
                    return _this.localize("NaFila");
                else if (status == status_queue_1.default.atendimentoIniciado)
                    return _this.localize("AtendimentoIniciado");
                else if (status == status_queue_1.default.emAtendimento)
                    return _this.localize("EmAtendimento");
                else if (status == status_queue_1.default.atendimentoEncerrado)
                    return _this.localize("AtendimentoEncerrado");
                else if (status == status_queue_1.default.atendimentoInativo)
                    return _this.localize("AtendimentoInativo");
                else if (status == status_queue_1.default.atendimentoCancelado)
                    return _this.localize("AtendimentoCancelado");
                else if (status == status_queue_1.default.atendimentoAgendado)
                    return _this.localize("Agendado");
            }
        };
        _this.setActiveTabId = function (index, status) {
            _this.setState({
                status: index,
                statusQueue: status,
                statusLabel: _this.getTabStatusLocale()[index - 1].title,
                loadingRows: true,
            });
            if (index == 1) {
                _this.getAllMeetingData("'" + status_queue_1.default.naFila + "', '" + status_queue_1.default.atendimentoAgendado + "'", _this.state.selectedDateFilter, _this.state.selectedAtendenteFilter, _this.state.selectedFilter);
            }
            else if (index == 2) {
                _this.getAllMeetingData("'" + status_queue_1.default.atendimentoIniciado + "', '" + status_queue_1.default.emAtendimento + "'", _this.state.selectedDateFilter, _this.state.selectedAtendenteFilter, _this.state.selectedFilter);
            }
            else if (index == 3) {
                _this.setState({
                    statusQueue: index,
                });
                _this.getAllMeetingData(index, _this.state.selectedDateFilter, _this.state.selectedAtendenteFilter, _this.state.selectedFilter);
            }
            else if (index == 4) {
                _this.setState({
                    statusQueue: index,
                });
                _this.getAllMeetingData(index, _this.state.selectedDateFilter, _this.state.selectedFilter);
            }
        };
        _this.atender = function (item) {
            item.loadingMeeting = true;
            _this.setState({
                items: _this.state.items
            });
            serventias_api_1.getQueueById(item.id).then(function (queue) {
                if (queue.data.status == status_queue_1.default.atendimentoIniciado ||
                    queue.data.status == status_queue_1.default.emAtendimento) {
                    _this.setState({
                        startedCall: true,
                        startedCallAttendant: queue.data.atendenteName,
                    });
                }
                else if (queue.data.status == status_queue_1.default.naFila || queue.data.status == status_queue_1.default.atendimentoAgendado) {
                    serventias_api_1.createOnlineMeetingAndUpdateStatus(item.id, item.Ancora, _this.appId).then(function (response) {
                        item.loadingMeeting = false;
                        _this.setState({
                            items: _this.state.items
                        });
                        if (response.data.id) {
                            microsoftTeams.executeDeepLink(response.data.meetingUrl);
                            _this.getAllMeetingData(null, _this.state.selectedDateFilter)
                                .then(function (item) { return _this.setActiveTabId(2, "'" + status_queue_1.default.atendimentoIniciado + "', '" + status_queue_1.default.emAtendimento + "'"); });
                        }
                        else {
                            _this.setState({
                                validateCreateQueue: false,
                                validateQueueErrorText: response.data,
                            });
                        }
                    });
                }
            });
        };
        _this.finalizar = function (item) {
            serventias_api_1.endCall(item.id).then(function (response) {
                item.loadingEndMeeting = false;
                _this.getAllMeetingData(null, _this.state.selectedDateFilter).then(function (item) {
                    return _this.setActiveTabId(3, "'" + status_queue_1.default.atendimentoEncerrado + "', \n                    '" + status_queue_1.default.atendimentoInativo + "', \n                    '" + status_queue_1.default.atendimentoCancelado + "'");
                });
            });
        };
        _this.onViewHistory = function (queueId) {
            var taskInfo = {
                url: window.location.origin + ("/post-meeting-panel/" + queueId + "/" + _this.ancora),
                title: _this.localize("Detalhes"),
                height: 650,
                width: 930,
            };
            microsoftTeams.tasks.startTask(taskInfo);
        };
        _this.agendar = function (queueId) {
            var taskInfo = {
                url: window.location.origin + ("/agendamento?ancora=" + _this.ancora + (queueId ? "&queueId=" + queueId : '')),
                title: _this.localize("Agendamento"),
                height: 630,
                width: 360,
            };
            var submitHandler = function (err, result) {
                if (result) {
                    _this.setActiveTabId(1, "'" + status_queue_1.default.naFila + "', '" + status_queue_1.default.atendimentoAgendado + "'");
                }
            };
            microsoftTeams.tasks.startTask(taskInfo, submitHandler);
        };
        _this.onCancelCall = function (queueId) {
            serventias_api_1.cancelCall(queueId).then(function (response) {
                _this.getAllMeetingData(null, _this.state.selectedDateFilter).then(function (item) {
                    return _this.setActiveTabId(3, "'" + status_queue_1.default.atendimentoEncerrado + "',\n                    '" + status_queue_1.default.atendimentoInativo + "', \n                    '" + status_queue_1.default.atendimentoCancelado + "'");
                });
            });
        };
        _this.collapseCharts = function (collapsed) {
            _this.setState({
                collapsed: collapsed
            });
        };
        _this.onValidateCreateQueue = function () {
            _this.setState({ validateCreateQueue: true });
        };
        _this.localize = _this.props.t;
        Icons_1.initializeIcons();
        _this.state = {
            totalItemsCount: [],
            items: [],
            itemsClone: [],
            appConfigs: null,
            loading: true,
            pageSize: _this.defaultPageSize,
            activePage: 0,
            sortedColumn: "Name",
            sortDirection: "Down",
            totalFilterChecked: 0,
            itemsSecaoFilter: [],
            metricsFiltered: [],
            totalIndex: 0,
            totalMetricsFiltered: [],
            loadingTotalMetricsFiltered: false,
            loadingRows: false,
            isAdmin: false,
            serventia: [],
            loadingMetricsFiltered: false,
            relatorioAtendimentosFilteredMetrics: [],
            relatorioAtendimentosIndex: 0,
            loadingAtendimentosPorStatusMetricsFiltered: false,
            atendimentosPorStatusMetricsFiltered: [],
            atendimentosPorStatusIndex: 0,
            atendimentosMetricsFiltered: [],
            atendimentosTotalMetrics: [],
            loadingAtendimentosMetricsFiltered: false,
            loadingAtendimentosTotalMetrics: false,
            atendimentosIndex: 0,
            userSettings: [],
            status: 1,
            statusQueue: "'" + status_queue_1.default.naFila + "', '" + status_queue_1.default.atendimentoAgendado + "'",
            statusLabel: _this.localize("SolicitacoesAguardandoAtendimento"),
            queueCount1: [],
            queueCount2: [],
            queueCount3: [],
            queueCount4: [],
            interval: null,
            isDeleted: false,
            startedCall: false,
            startedCallAttendant: "",
            validateCreateQueue: true,
            validateQueueErrorText: "",
            isScheduledQueue: false,
            selectedDateFilter: new Date(),
            authEnabled: false,
            govBrEnabled: false,
            isFuture: false,
            isPast: false,
            collapsed: true,
            selectedFilter: "",
            atendentes: [],
            selectedAtendenteFilter: "",
            internalAccessEnabled: false,
        };
        _this.searchParam = new URLSearchParams(window.location.search);
        return _this;
    }
    PainelAtendimento.prototype.componentDidMount = function () {
        var _this = this;
        microsoftTeams.initialize();
        microsoftTeams.getContext(function (context) {
            var _a;
            _this.ancora = context.subEntityId.split(", ")[0];
            _this.serventiaTitle = context.subEntityId.split(", ")[1];
            _this.appId = (_a = context.subEntityId.split(", ")[2]) !== null && _a !== void 0 ? _a : _this.searchParam.get("appId");
            _this.theme = context.theme;
            _this.upn = context.userPrincipalName;
            _this.aadId = context.userObjectId;
            _this.user = context.loginHint;
            _this.tid = context.tid;
            _this.getUserSettings();
        });
    };
    /**
    * Get meeting queue data.
    */
    PainelAtendimento.prototype.getAllMeetingData = function (status, date, atendenteId, filters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (date) {
                            date = moment(date).toISOString();
                        }
                        // Atendimento encerrado || Atendimento encerrado por inatividade;
                        // Atendimentos finalizados -> AtendenteId != null;
                        if (status == 3) {
                            this.getEndedQueuesData(date, atendenteId, filters);
                            return [2 /*return*/];
                            // Atendimentos expirados -> AtendenteId == null;
                        }
                        else if (status == 4) {
                            this.getExpiredQueuesData(date, filters);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, serventias_api_1.getAllQueuesData(this.ancora, status, date, atendenteId, filters)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                items: response.data,
                                loadingRows: false,
                            });
                            this.getQueuesStatusCount(date, atendenteId, filters);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
    * Get ended queue data.
    */
    PainelAtendimento.prototype.getEndedQueuesData = function (date, atendenteId, filters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, serventias_api_1.getEndedQueues(this.ancora, date, atendenteId, filters)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                items: response.data,
                                loadingRows: false,
                            });
                            this.getQueuesStatusCount(date, atendenteId, filters);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
    * Get expired queue data.
    */
    PainelAtendimento.prototype.getExpiredQueuesData = function (date, filters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, serventias_api_1.getExpiredQueues(this.ancora, date, filters)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                items: response.data,
                                loadingRows: false,
                            });
                            this.getQueuesStatusCount(date);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
    * Get queues status count.
    */
    PainelAtendimento.prototype.getQueuesStatusCount = function (date, atendenteId, filters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (date) {
                            date = moment(date).toISOString();
                        }
                        return [4 /*yield*/, serventias_api_1.getQueuesStatusCount(this.ancora, date, atendenteId, filters)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                queueCount1: response.data.filter(function (queue) { return queue.status == status_queue_1.default.naFila || queue.status == status_queue_1.default.atendimentoAgendado; }),
                                queueCount2: response.data.filter(function (queue) { return queue.status == status_queue_1.default.atendimentoIniciado || queue.status == status_queue_1.default.emAtendimento; }),
                                queueCount3: response.data.filter(function (queue) { return (queue.status == status_queue_1.default.atendimentoEncerrado || queue.status == status_queue_1.default.atendimentoInativo || queue.status == status_queue_1.default.atendimentoCancelado) && (!queue.expired || queue.status == status_queue_1.default.atendimentoCancelado); }),
                                queueCount4: response.data.filter(function (queue) { return queue.status == status_queue_1.default.atendimentoInativo && queue.expired; }),
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    PainelAtendimento.prototype.getTabStatusLocale = function () {
        return [
            { title: this.localize("SolicitacoesAguardandoAtendimento") },
            { title: this.localize("AtendimentosIniciados") },
            { title: this.localize("EmAtendimento") },
            { title: this.localize("SolicitacoesExpiradas") },
        ];
    };
    PainelAtendimento.prototype.render = function () {
        var _this = this;
        var itemsArr = [];
        for (var j = 0; j < this.state.pageSize; j++) {
            if (j >= this.state.items.length) {
                break;
            }
            var item = this.state.items[j];
            var queue = (item === null || item === void 0 ? void 0 : item.queue) ? item === null || item === void 0 ? void 0 : item.queue : item;
            if (this.state.status == 1) {
                itemsArr.push(React.createElement(listagem_fila_1.default, { index: j, queue: queue, scheduleQueue: item.schedule, scheduleDay: item.scheduleDay, scheduleDayInRange: item.scheduleDayInRange, getLabelStatusLocale: this.getLabelStatusLocale, onCancelCall: this.onCancelCall, validateCreateQueue: this.state.validateCreateQueue, validateQueueErrorText: this.state.validateQueueErrorText, onValidateCreateQueue: this.onValidateCreateQueue, startCall: this.atender, agendar: this.agendar, authEnabled: this.state.authEnabled, govBrEnabled: this.state.govBrEnabled, filtered: (this.state.selectedFilter != "") || (this.state.selectedAtendenteFilter != ""), internalAccessEnabled: this.state.internalAccessEnabled }));
            }
            else if (this.state.status == 2) {
                itemsArr.push(React.createElement(listagem_iniciado_1.default, { index: j, item: item, queue: queue, getLabelStatusLocale: this.getLabelStatusLocale, authEnabled: this.state.authEnabled, govBrEnabled: this.state.govBrEnabled, internalAccessEnabled: this.state.internalAccessEnabled, aadId: this.aadId, finalizar: this.finalizar }));
            }
            else if (this.state.status == 3) {
                itemsArr.push(React.createElement(listagem_encerrado_1.default, { index: j, item: item, getLabelStatusLocale: this.getLabelStatusLocale, onViewHistory: this.onViewHistory, authEnabled: this.state.authEnabled, govBrEnabled: this.state.govBrEnabled, filtered: (this.state.selectedFilter != "") || (this.state.selectedAtendenteFilter != ""), internalAccessEnabled: this.state.internalAccessEnabled }));
            }
            else if (this.state.status == 4) {
                itemsArr.push(React.createElement(listagem_expirado_1.default, { index: j, queue: queue, getLabelStatusLocale: this.getLabelStatusLocale, onViewHistory: this.onViewHistory }));
            }
        }
        var segmentRows = [];
        if (this.state.loadingRows)
            segmentRows.push(React.createElement(react_northstar_1.Segment, { styles: { gridColumn: 'span 6', background: 'transparent', paddingTop: '0px', boxShadow: 'none' } },
                React.createElement(loaderList_1.default, null)));
        else
            segmentRows.push(itemsArr);
        return (
        //this.state.loadingMetrics ||
        this.state.metricsFiltered.length == 0 ||
            this.state.loadingAtendimentosTotalMetrics ||
            this.state.loadingAtendimentosMetricsFiltered ||
            this.state.loadingAtendimentosPorStatusMetricsFiltered ||
            this.state.loadingMetricsFiltered ?
            React.createElement(loaderPainel_1.default, null)
            :
                !this.ancora ?
                    React.createElement("div", { className: "main-component-painel" },
                        React.createElement("div", { className: "form-container" },
                            React.createElement(react_northstar_1.Flex, null,
                                React.createElement(react_northstar_1.Flex, { vAlign: "center", hAlign: "center", styles: { width: "100%", height: "100vh" } },
                                    React.createElement(react_northstar_1.Flex, { hAlign: "center", gap: "gap.large", column: true, style: { width: "100%", maxWidth: "43.5rem", margin: "0rem 1.25rem", height: "90rem" } },
                                        React.createElement(react_northstar_1.Image, { src: "/images/empty-unit.svg" }),
                                        React.createElement(react_northstar_1.Text, { size: "larger", content: "Voc\u00EA ainda n\u00E3o acessou uma unidade." }),
                                        React.createElement(react_northstar_1.Text, { content: this.localize("SelecioneServentia") }))))))
                    :
                        React.createElement("div", { className: "main-component-painel" },
                            React.createElement("div", { className: "form-container" },
                                React.createElement(react_northstar_1.Flex, { gap: "gap.large", space: "between" },
                                    React.createElement(react_northstar_1.FlexItem, { size: "size.quarter" },
                                        React.createElement(react_northstar_1.Segment, { styles: { boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" } }, React.createElement(visao_geral_atendimentos_1.default, { metrics: this.state.atendimentosMetricsFiltered, totalMetrics: this.state.atendimentosTotalMetrics, filter: this.getAtendimentosFilteredMetrics, index: this.state.atendimentosIndex, customTitle: this.serventiaTitle, collapseCharts: this.collapseCharts, collapsed: this.state.collapsed }))),
                                    React.createElement(react_northstar_1.FlexItem, { size: "size.quarter" },
                                        React.createElement(react_northstar_1.Segment, { styles: { boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" } },
                                            React.createElement(visao_geral_atendimentos_status_1.default, { metrics: this.state.atendimentosPorStatusMetricsFiltered, filter: this.getAtendimentosPorStatusFilteredMetrics, index: this.state.atendimentosPorStatusIndex, collapseCharts: this.collapseCharts, collapsed: this.state.collapsed }))),
                                    React.createElement(react_northstar_1.FlexItem, { size: "size.half" },
                                        React.createElement(react_northstar_1.Segment, { styles: { boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" } }, React.createElement(relatorio_atendimentos_1.default, { metrics: this.state.relatorioAtendimentosFilteredMetrics, filter: this.getRelatorioAtendimentosFilteredMetrics, index: this.state.relatorioAtendimentosIndex, collapseCharts: this.collapseCharts, collapsed: this.state.collapsed })))),
                                React.createElement(react_northstar_1.Flex, { hidden: this.state.isDeleted, space: "between", className: "toolbar-painel", styles: { boxShadow: "rgba(0 0 0 / 21%) 0 8px 6px -6px" } },
                                    React.createElement(toolbar_1.default, { ancora: this.ancora, status: this.state.status, setActiveTabId: this.setActiveTabId, queueCount1: this.state.queueCount1, queueCount2: this.state.queueCount2, queueCount3: this.state.queueCount3, queueCount4: this.state.queueCount4, agendar: this.agendar, isScheduledQueue: this.state.isScheduledQueue, dataChange: this.dateChange, selectedDateFilter: this.state.selectedDateFilter, isFuture: this.state.isFuture, isPast: this.state.isPast, searchFilters: this.searchFilters, selectedFilter: this.state.selectedFilter, clearFilters: this.clearFilters, applyFilters: this.applyFilters, applyProtocolFilter: this.applyProtocolFilter, atendentes: this.state.atendentes, getAtendentesByDate: this.getAtendentes, selectedAtendenteFilter: this.state.selectedAtendenteFilter })),
                                React.createElement("div", { className: "form-content-container" },
                                    (this.state.items.length === 0 && !this.state.loadingRows && !this.state.isDeleted && this.state.status != 0) &&
                                        React.createElement(react_northstar_1.Flex, { hAlign: "center", gap: "gap.medium", styles: { marginTop: '60px' } },
                                            React.createElement(react_icons_northstar_1.ExclamationTriangleIcon, { outline: true }),
                                            React.createElement(react_northstar_1.Text, { size: "small", weight: "light", content: this.localize("NaoExistem") + " " + this.state.statusLabel + " " + this.localize("NestaUnidade") })),
                                    (this.state.items.length === 0 && !this.state.loadingRows && !this.state.isDeleted && this.state.status == 0) &&
                                        React.createElement(react_northstar_1.Flex, { hAlign: "center", gap: "gap.medium", styles: { marginTop: '60px' } },
                                            React.createElement(react_icons_northstar_1.ExclamationTriangleIcon, { outline: true }),
                                            React.createElement(react_northstar_1.Text, { size: "small", weight: "light", content: "N\u00E3o existem atendimentos com o filtro selecionado." })),
                                    this.state.loadingRows && React.createElement(loaderList_1.default, null),
                                    React.createElement(react_northstar_1.Dialog, { open: this.state.startedCall, onConfirm: function () { return _this.setState({ startedCall: false }); }, confirmButton: "Ok", content: this.localize("SolicitacaoJaAtendida") + " " + this.state.startedCallAttendant + ".", header: this.localize("AtenderEstaSolicitacao") }),
                                    (this.state.items.length > 0 && !this.state.loadingRows && this.state.status == 1) &&
                                        React.createElement(react_northstar_1.Grid, { columns: ((this.state.authEnabled && this.state.govBrEnabled || this.state.internalAccessEnabled)) ?
                                                'minmax(300px, 380px) minmax(70px, 70px) 0.5fr 0.7fr 2.5fr 0.5fr' :
                                                'minmax(300px, 380px) minmax(70px, 70px) 0.5fr 2.5fr 0.5fr' },
                                            React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header" },
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Text, { content: this.localize("StatusAtendimento"), className: "margin-style header-nome-serventia" })),
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: React.createElement(React.Fragment, null,
                                                            React.createElement(react_northstar_1.Text, { content: "\u25CF " + this.localize("UsuarioNaFila") }),
                                                            React.createElement("br", null),
                                                            React.createElement("br", null),
                                                            React.createElement(react_northstar_1.Text, { content: "\u25CF " + this.localize("AtendimentoConfirmado") }),
                                                            React.createElement("br", null),
                                                            React.createElement("br", null),
                                                            React.createElement(react_northstar_1.Text, { content: "\u25CF " + this.localize("UsuarioEntrou") })) }))),
                                            React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header" }),
                                            React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header" },
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Text, { className: "margin-style", content: this.localize("Horario") })),
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: this.localize("HorarioSolicitacao") }))),
                                            ((this.state.authEnabled && this.state.govBrEnabled) || this.state.internalAccessEnabled) &&
                                                React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header" },
                                                    React.createElement(react_northstar_1.FlexItem, null,
                                                        React.createElement(react_northstar_1.Text, { className: "margin-style", content: "Solicitante" }))),
                                            React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header" },
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Text, { className: "margin-style", content: this.localize("Assunto") })),
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: this.localize("AssuntoAtendimento") }))),
                                            React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header" },
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Text, { className: "margin-style", content: this.localize("Atendimento") })),
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: this.localize("InformacoesAtendente") }))),
                                            segmentRows),
                                    (this.state.items.length > 0 && !this.state.loadingRows && this.state.status == 2) &&
                                        React.createElement(react_northstar_1.Grid, { columns: ((this.state.authEnabled && this.state.govBrEnabled || this.state.internalAccessEnabled)) ?
                                                'minmax(300px, 380px) minmax(70px, 70px) 0.5fr 0.7fr 1fr 0.5fr 0.5fr' :
                                                'minmax(300px, 380px) minmax(70px, 70px) 0.5fr 1fr 0.5fr 0.5fr' },
                                            React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header" },
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Text, { content: this.localize("StatusAtendimento"), className: "margin-style header-nome-serventia" })),
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: React.createElement(React.Fragment, null,
                                                            React.createElement(react_northstar_1.Text, { content: "\u25CF " + this.localize("UsuarioNaFila") }),
                                                            React.createElement("br", null),
                                                            React.createElement("br", null),
                                                            React.createElement(react_northstar_1.Text, { content: "\u25CF " + this.localize("AtendimentoConfirmado") }),
                                                            React.createElement("br", null),
                                                            React.createElement("br", null),
                                                            React.createElement(react_northstar_1.Text, { content: "\u25CF " + this.localize("UsuarioEntrou") })) }))),
                                            React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header" }),
                                            React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header" },
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Text, { className: "margin-style", content: this.localize("IniciadoEm") })),
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: this.localize("HorarioSolicitacaoIniciada") }))),
                                            ((this.state.authEnabled && this.state.govBrEnabled) || this.state.internalAccessEnabled) &&
                                                React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header" },
                                                    React.createElement(react_northstar_1.FlexItem, null,
                                                        React.createElement(react_northstar_1.Text, { className: "margin-style", content: "Solicitante" }))),
                                            React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header" },
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Text, { className: "margin-style", content: this.localize("Assunto") })),
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: this.localize("AssuntoAtendimento") }))),
                                            React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header" },
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Text, { className: "margin-style", content: this.localize("Atendimento") })),
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: this.localize("InformacoesAtendente") }))),
                                            React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header", hAlign: "center" },
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Text, { className: "margin-style", content: this.localize("Atendente") })),
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: this.localize("Atendente") }))),
                                            segmentRows),
                                    (this.state.items.length > 0 && !this.state.loadingRows && this.state.status == 3) &&
                                        React.createElement(react_northstar_1.Grid, { columns: ((this.state.authEnabled && this.state.govBrEnabled || this.state.internalAccessEnabled)) ?
                                                'minmax(300px, 380px) minmax(70px, 70px) 0.5fr 0.5fr 0.2fr 0.3fr 0.5fr 0.2fr 0.5fr' :
                                                'minmax(300px, 380px) minmax(70px, 70px) 0.5fr 0.2fr 0.3fr 0.5fr 0.2fr 0.5fr' },
                                            React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header" },
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Text, { content: this.localize("StatusAtendimento"), className: "margin-style header-nome-serventia" })),
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: React.createElement(React.Fragment, null,
                                                            React.createElement(react_northstar_1.Text, { content: "\u25CF " + this.localize("UsuarioNaFila") }),
                                                            React.createElement("br", null),
                                                            React.createElement("br", null),
                                                            React.createElement(react_northstar_1.Text, { content: "\u25CF " + this.localize("AtendimentoConfirmado") }),
                                                            React.createElement("br", null),
                                                            React.createElement("br", null),
                                                            React.createElement(react_northstar_1.Text, { content: "\u25CF " + this.localize("UsuarioEntrou") })) }))),
                                            React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header" }),
                                            ((this.state.authEnabled && this.state.govBrEnabled) || this.state.internalAccessEnabled) &&
                                                React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header" },
                                                    React.createElement(react_northstar_1.FlexItem, null,
                                                        React.createElement(react_northstar_1.Text, { className: "margin-style", content: "Solicitante" }))),
                                            React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header" },
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Text, { className: "margin-style", content: this.localize("AtendidoPor") })),
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: this.localize("AtendenteResponsavel") }))),
                                            React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header", hAlign: "center" },
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Text, { className: "margin-style", content: this.localize("Horario") })),
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: this.localize("HorarioSolicitacao") }))),
                                            React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header", hAlign: "center" },
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Text, { className: "margin-style", content: this.localize("TempoEspera") })),
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: this.localize("TempoEsperaAtendimento") }))),
                                            React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header", hAlign: "center" },
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Text, { className: "margin-style", content: this.localize("HorarioAtendimento") })),
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: this.localize("HorarioAtendimento") }))),
                                            React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header", hAlign: "center" },
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Text, { className: "margin-style", content: this.localize("TempoAtendimento") })),
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: this.localize("TempoAtendimento") }))),
                                            React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header", hAlign: "center" },
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Text, { className: "margin-style", content: this.localize("HorarioEncerramento") })),
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: this.localize("HorarioEncerramento") }))),
                                            segmentRows),
                                    (this.state.items.length > 0 && !this.state.loadingRows && this.state.status == 4) &&
                                        React.createElement(react_northstar_1.Grid, { columns: "minmax(300px, 380px) minmax(30px, 30px) 0.5fr 0.5fr" },
                                            React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header" },
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Text, { content: this.localize("StatusAtendimento"), className: "margin-style header-nome-serventia" })),
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: React.createElement(React.Fragment, null,
                                                            React.createElement(react_northstar_1.Text, { content: "\u25CF " + this.localize("UsuarioNaFila") }),
                                                            React.createElement("br", null),
                                                            React.createElement("br", null),
                                                            React.createElement(react_northstar_1.Text, { content: "\u25CF " + this.localize("AtendimentoConfirmado") }),
                                                            React.createElement("br", null),
                                                            React.createElement("br", null),
                                                            React.createElement(react_northstar_1.Text, { content: "\u25CF " + this.localize("UsuarioEntrou") })) }))),
                                            React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header" }),
                                            React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header", hAlign: "center" },
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Text, { className: "margin-style", content: this.localize("Horario") })),
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: this.localize("HorarioSolicitacao") }))),
                                            React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header", hAlign: "center" },
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Text, { className: "margin-style", content: this.localize("HorarioEncerramento") })),
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: this.localize("HorarioEncerramento") }))),
                                            segmentRows)))));
    };
    return PainelAtendimento;
}(React.Component));
var painelAtendimentoWithTranslation = react_i18next_1.withTranslation()(PainelAtendimento);
exports.default = painelAtendimentoWithTranslation;
//# sourceMappingURL=painel-atendimento.js.map